<template>
    <div id="box_body">
        <div class="top_banner" >
            <div class="top_banner_text">
                <p>帮助中心</p>
                <p>Help&nbsp;&nbsp;center</p>
            </div>
        </div>
        <van-sticky :offset-top="50">
            <div class="tab" id="tab"  :class="{'is_fixed' : isFixed}">
                <div class="tab_test">
                    <div class="list" @click="get_top(0)">
                        <img src="@/assets/img/tab/changjian.png">
                        <p>常见问题</p>
                    </div>
                    <div class="list" @click="get_top(1)">
                        <img src="@/assets/img/tab/zhuce.png">
                        <p>注册登录问题</p>
                    </div>
                    <div class="list" @click="get_top(2)">
                        <img src="@/assets/img/tab/shiming.png">
                        <p>实名认证</p>
                    </div>
                    <div class="list" @click="get_top(3)">
                        <img src="@/assets/img/tab/qianshu.png">
                        <p>签署发起文件</p>
                    </div>
                    <div class="list" @click="get_top(4)">
                        <img src="@/assets/img/tab/hetong.png">
                        <p>合同管理</p>
                    </div>
                    <div class="list" @click="get_top(5)">
                        <img src="@/assets/img/tab/zhanghao.png">
                        <p>账号管理</p>
                    </div>
                    <div class="list" @click="get_top(6)">
                        <img src="@/assets/img/tab/chanpin.png">
                        <p>产品费用问题</p>
                    </div>
                    <div class="list" @click="get_top(7)">
                        <img src="@/assets/img/tab/falv.png">
                        <p>法律法规问题</p>
                    </div>
                </div>
            </div>
        </van-sticky>


        <div class="test" >
            <div class="new_de_right_btm">
                <p class="test_top">常见问题</p>
                <div class="recommend" v-for="(item,t) in html" :key="t" @click="fun_add(item.id)">
                    <p class="article">
                        {{item.helpTitle}}
                    </p>
                </div>
                <div class="nodData" v-if="html.length==0">
                    <img src="@/assets/img/nodata.png">
                    <p> 暂无数据</p>
                </div>
            </div>
            <div class="new_de_right_btm">
                <p class="test_top">注册、登录问题</p>
                <div class="recommend" v-for="(item,t) in html_1" :key="t+'001'" @click="fun_add(item.id)">
                    <p class="article">
                        {{item.helpTitle}}
                    </p>
                </div>
                <div class="nodData" v-if="html_1.length==0">
                    <img src="@/assets/img/nodata.png">
                    <p> 暂无数据</p>
                </div>
            </div>
            <div class="new_de_right_btm">
                <p class="test_top">实名认证</p>
                <div  class="recommend" v-for="(item,t) in html_2" :key="t+'002'" @click="fun_add(item.id)">
                    <p class="article">
                        {{item.helpTitle}}
                    </p>
                </div>
                <div class="nodData" v-if="html_2.length==0">
                    <img src="@/assets/img/nodata.png">
                    <p> 暂无数据</p>
                </div>
            </div>
            <div class="new_de_right_btm">
                <p class="test_top">签署发起文件</p>
                <div class="recommend" v-for="(item,t) in html_3" :key="t+'003'" @click="fun_add(item.id)">
                    <p class="article">
                        {{item.helpTitle}}
                    </p>
                </div>
                <div class="nodData" v-if="html_3.length==0">
                    <img src="@/assets/img/nodata.png">
                    <p> 暂无数据</p>
                </div>
            </div>
            <div class="new_de_right_btm">
                <p class="test_top">合同管理</p>
                <div class="recommend" v-for="(item,t) in html_4" :key="t+'004'" @click="fun_add(item.id)">
                    <p class="article">
                        {{item.helpTitle}}
                    </p>
                </div>
                <div class="nodData" v-if="html_4.length==0">
                    <img src="@/assets/img/nodata.png">
                    <p> 暂无数据</p>
                </div>
            </div>
            <div class="new_de_right_btm">
                <p class="test_top">账号管理</p>
                <div class="recommend" v-for="(item,t) in html_5" :key="t+'005'" @click="fun_add(item.id)">
                    <p class="article">
                        {{item.helpTitle}}
                    </p>
                </div>
                <div class="nodData" v-if="html_5.length==0">
                    <img src="@/assets/img/nodata.png">
                    <p> 暂无数据</p>
                </div>
            </div>
            <div class="new_de_right_btm">
                <p class="test_top">产品费用问题</p>
                <div class="recommend" v-for="(item,t) in html_6" :key="t+'006'" @click="fun_add(item.id)">
                    <p class="article">
                        {{item.helpTitle}}
                    </p>
                </div>
                <div class="nodData" v-if="html_6.length==0">
                    <img src="@/assets/img/nodata.png">
                    <p> 暂无数据</p>
                </div>
            </div>
            <div class="new_de_right_btm">
                <p class="test_top">法律法规问题</p>
                <div class="recommend" v-for="(item,t) in html_7" :key="t+'007'" @click="fun_add(item.id)">
                    <p class="article">
                        {{item.helpTitle}}
                    </p>
                </div>
                <div class="nodData" v-if="html_7.length==0">
                    <img src="@/assets/img/nodata.png">
                    <p> 暂无数据</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "helpCenter",
        data() {
            return {
                html: [],
                html_1: [],
                html_2: [],
                html_3: [],
                html_4: [],
                html_5: [],
                html_6: [],
                html_7: [],
                isFixed:false,
                sttusCode: [],
                hide_pagination: false,
                test: '',
                pageSize: 50,
                pageNum: 1,
                pages_total: 0,
                newsType: '',
            }
        },
        mounted() {
            var add_dome = document.getElementById('app')
            add_dome.addEventListener("scroll",this.handleScroll);
            this.git_data()
            this.git_query()
        },
        methods: {
            get_top(i){
                var box = document.getElementsByClassName('new_de_right_btm')
                var top = box[i].offsetTop
                document.querySelector('#app').scrollTop = top-218
                this.handleScroll()
            },
            handleScroll(){
                var top = document.querySelector('#app').scrollTop
                var list = document.getElementsByClassName("list")
                var box = document.getElementsByClassName('new_de_right_btm')
                this.box_top_1 = box[1].offsetTop
                this.box_top_2 = box[2].offsetTop
                this.box_top_3 = box[3].offsetTop
                this.box_top_4 = box[4].offsetTop
                this.box_top_5 = box[5].offsetTop
                this.box_top_6 = box[6].offsetTop
                this.box_top_7 = box[7].offsetTop
                for(var i = 0; i<8;i++){
                    list[i].style.border = '1px solid rgba(234, 234, 234, 1)'
                    list[i].style.color = '#000'
                }
                if(top>=0 && top < this.box_top_1 -220){
                    list[0].style.border = '1px solid rgba(49,202,132,1)'
                    list[0].style.color = 'rgba(49,202,132,1)'
                }else if(top>this.box_top_1 -220 && top < this.box_top_2 -220){
                    list[1].style.border = '1px solid rgba(49,202,132,1)'
                    list[1].style.color = 'rgba(49,202,132,1)'
                }else if(top>this.box_top_2 -220 && top < this.box_top_3 -220){
                    list[2].style.border = '1px solid rgba(49,202,132,1)'
                    list[2].style.color = 'rgba(49,202,132,1)'
                }else if(top>this.box_top_3 -220 && top < this.box_top_4 -220){
                    list[3].style.border = '1px solid rgba(49,202,132,1)'
                    list[3].style.color = 'rgba(49,202,132,1)'
                }else if(top>this.box_top_4 -220 && top < this.box_top_5 -220){
                    list[4].style.border = '1px solid rgba(49,202,132,1)'
                    list[4].style.color = 'rgba(49,202,132,1)'
                }else if(top>this.box_top_5 -220 && top < this.box_top_6 -220){
                    list[5].style.border = '1px solid rgba(49,202,132,1)'
                    list[5].style.color = 'rgba(49,202,132,1)'
                }else if(top>this.box_top_6 -220 && top < this.box_top_7 -220){
                    list[6].style.border = '1px solid rgba(49,202,132,1)'
                    list[6].style.color = 'rgba(49,202,132,1)'
                }else if(top>this.box_top_7 -220){
                    list[7].style.border = '1px solid rgba(49,202,132,1)'
                    list[7].style.color = 'rgba(49,202,132,1)'
                }

            },
            fun_add(id){
                this.$router.push({ name: 'helpCenterDetails', params: { newsId:id} });
            },
            git_query(){

                this.$SIF.httpPost({
                    url: this.$SIF._serve.menhu + "/code/query",
                    data: {typeClass: "helpType"},
                    succFun: res => {
                        console.log(res)
                    },
                    failFun: res => {

                    }
                });
            },
            git_data(){
                var params = {
                    entity: {

                    },
                    pageBean: {
                        pageNum: this.pageNum,
                        pageSize: this.pageSize
                    }
                };
                this.$SIF.httpPost({
                    url: this.$SIF._serve.menhu + "/help/queryPage",
                    data: params,
                    succFun: res => {
                        var newData = res.data.list;
                        // this.sttusCode = res.data.list;
                        this.pages_total = res.data.total;
                        for (var i =0;i<newData.length;i++){
                            if (newData[i].helpType == '3001') {
                                this.html.push(newData[i])
                            } else if (newData[i].helpType == '3002') {
                                this.html_1.push(newData[i])
                            } else if (newData[i].helpType == '3003') {
                                this.html_2.push(newData[i])
                            } else if (newData[i].helpType == '3004') {
                                this.html_3.push(newData[i])
                            } else if (newData[i].helpType == '3005') {
                                this.html_4.push(newData[i])
                            } else if (newData[i].helpType == '3006') {
                                this.html_5.push(newData[i])
                            } else if (newData[i].helpType == '3007') {
                                this.html_6.push(newData[i])
                            } else if (newData[i].helpType == '3008') {
                                this.html_7.push(newData[i])
                            }
                        }
                    },
                    failFun: res => {

                    }
                });
            }
        },
        destroyed() {
            document.removeEventListener('scroll', this.handleScroll)
        }
    }
</script>

<style scoped type="text/css">
    .top_banner {
        background-image: url(~@/assets/img/banner/banner.png);
        background-size: 100% 100%;

    }
    #box_body{
        height: 100%;
        overflow: hidden;
        background: #ffffff;
    }
    .new_de_right_btm .recommend{
        padding-left: 18px !important;
    }
    .test {
        width: 1200px;
        margin: 0 auto;

    }
    .nodData{
        width: 100%;
        text-align: center;
        padding: 30px 0;
        color: #0C9C5B;
    }
    .nodData p{
        padding-top: 15px;
    }

    .helpCenter {
        width: 1200px;
        height: 50px;
        margin: 0 auto;
        /*padding: 0 15%;*/
        /*position: fixed;*/
        background: #ffffff;
    }

    .search_box {
        float: right;
        top: 5px;
    }

    .recommend {
        padding-left: 18px;
        box-sizing: border-box;
        margin-bottom: 12px;
        cursor: pointer;
    }

    .recommend {
        height: 60px;
        line-height: 60px;
        background: rgba(245, 245, 245, 1);
    }
    .recommend:hover .article{
        color: #0C9C5B;
    }

    .article {
        line-height: 60px !important;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #323232;
    }

    .test_top {
        font-family: NotoSansHans-Medium, NotoSansHans;
        font-weight: 500;
        color: rgba(49, 202, 132, 1);
        line-height: 60px;
        letter-spacing: 1px;
        font-size: 16px;
        height: 60px;
    }
    .tab {
        width: 100%;
        height: 180px;
        overflow: hidden;
        background: #ffffff;
        /*position: fixed;*/
    }

    .selected {
        position: fixed;
        top: 74px;
        background: #ffffff;
    }

    .tab_test {
        width: 1200px;
        margin: 0 auto;
        padding: 10px 0;
    }

    .list {
        margin: 0 10px;
        width: 127px;
        float: left;
        text-align: center;
        border: 1px solid rgba(234, 234, 234, 1);
        padding: 15px 0;
        cursor: pointer;
    }

    .list:hover {
        border: 1px solid rgba(49, 202, 132, 1);
        color: rgba(49, 202, 132, 1);
    }

    .list p {
        padding: 10px 0;
    }

    .list_clic {
        border: 1px solid rgba(49, 202, 132, 1);
        color: rgba(49, 202, 132, 1);
    }
    .new_de_right_btm{
     border: none;
    }
</style>